var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPenalty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#444188",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#penalty_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.561.447v9.476M.438.447v9.476m0-9.476h15.123M8 4.275v2.51m0-2.51L9.255 5.53M8 4.275 6.745 5.53m1.254 3.138v1.749m-3.285.636 1.663.54m0 0 1.62-1.177 1.62 1.177m-3.24 0 .619 1.904M5.968 14.91l1.028-1.414m0 0h2.002m1.027 1.414-1.027-1.414m0 0 .618-1.904m1.663-.54-1.663.54m.823-1.914a3.451 3.451 0 1 1-4.881 4.88 3.451 3.451 0 0 1 4.88-4.88"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "penalty_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "5A5D64",
  d: "M0 0h16v16H0z"
})))));
export default SvgPenalty;